import { render, staticRenderFns } from "./GEODeadlinesForm.vue?vue&type=template&id=f68052ac&scoped=true&"
import script from "./GEODeadlinesForm.vue?vue&type=script&lang=js&"
export * from "./GEODeadlinesForm.vue?vue&type=script&lang=js&"
import style0 from "./GEODeadlinesForm.vue?vue&type=style&index=0&id=f68052ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68052ac",
  null
  
)

export default component.exports